export default __webpack_public_path__ + "static/media/emoji-capsule.5129dd0a.svg";